import React, {useState} from 'react';
import {View, Text, StyleSheet, Image} from 'react-native';
import {Card, Divider, IconButton, Menu} from 'react-native-paper';

export default function WorkOrderItem(props) {
  const [menuVisible, setMenuVisible] = useState(false);
  const {workOrder, editWorkOrder, deleteWorkOrder} = props;
  let {status, type, pictureImage, description, shortDescription} = workOrder;

  let statusTextStyle = localStyles.maintenanceStatusText;

  switch (status) {
    case 'Closed':
      statusTextStyle = [
        localStyles.maintenanceStatusText,
        localStyles.closedStatusText,
      ];
      break;
    case 'Open':
      statusTextStyle = [
        localStyles.maintenanceStatusText,
        localStyles.openStatusText,
      ];
      break;
    default:
      statusTextStyle = localStyles.maintenanceStatusText;
      break;
  }

  return (
    <Card style={localStyles.card} onPress={() => props.onPress()}>
      <View>
        <View style={localStyles.container}>
          <Image
            source={{
              uri: pictureImage
                ? `data:image/jpeg;base64,${pictureImage}`
                : 'https://dummyimage.com/110x88/cccccc/cccccc.png',
            }}
            style={localStyles.smallCardImage}
          />
          <View style={localStyles.textContainer}>
            <Text style={localStyles.typeText}>
              {type ? type : 'Unknown type'}
            </Text>
            <Text numberOfLines={2} style={{width: 200}}>
              {shortDescription ? shortDescription : description}
            </Text>
            <Text numberOfLines={2} style={{width: 200}}>
              {workOrder.locationIsAUnit
                ? workOrder.locationUnitDisplay
                : workOrder.location}
            </Text>
            <Text style={statusTextStyle}>
              {status ? status : 'Unnamed status'}
            </Text>
          </View>

        <View
            style={{
              marginTop: 16,
              marginRight: 16,
            }}>
           { status !== 'Closed' &&  <Menu
              visible={menuVisible}
              onDismiss={() => setMenuVisible(false)}
              anchor={
                <IconButton
                  icon="ellipsis-vertical"
                  iconColor={'#718096'}
                  size={24}
                  onPress={() => setMenuVisible(true)}
                />
              }>
              <>
                <Menu.Item
                  onPress={() => {
                    setMenuVisible(false);
                    editWorkOrder();
                  }}
                  title="Edit"
                />
                <Divider />
              </>
              <Menu.Item
                onPress={() => {
                  setMenuVisible(false);
                  deleteWorkOrder();
                }}
                title="Delete"
              />
            </Menu> }
          </View> 
        </View>
        <Text style={localStyles.dateText}>
          {new Date(workOrder.createdDateTime).toLocaleDateString()}
        </Text>
      </View>
    </Card>
  );
}

const localStyles = StyleSheet.create({
  card: {
    margin: 8,
  },
  container: {
    margin: 8,
    marginBottom: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 0,
  },
  textContainer: {
    flexDirection: 'column',
  },
  typeText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  menuTrigger: {
    paddingHorizontal: 16,
    paddingVertical: 16,
    marginTop: 16,
  },
  dateText: {
    textAlign: 'right',
    paddingHorizontal: 32,
    fontSize: 12,
    paddingBottom: 8,
  },
  smallCardImage: {
    height: 80,
    width: 80,
    borderRadius: 4,
  },
  maintenanceStatusText: {
    paddingVertical: 4,
    borderRadius: 4,
  },
  closedStatusText: {
    color: '#D32F2F',
    fontWeight: 'bold',
    fontSize: 16,
  },
});
